export const CHECK_AUTH_TYPE = "CHECK_AUTH_TYPE"
export const CHECK_AUTH_TYPE_SUCCESSFUL = "CHECK_AUTH_TYPE_successfull"
export const CHECK_AUTH_TYPE_FAILED = "CHECK_AUTH_TYPE_failed"
